import Empty from './empty.vue'
export default Empty



// WEBPACK FOOTER //
// ./src/components/empty/index.js